var _path, _path2, _path3, _path4, _path5, _g, _g2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgMissingCardsWhite = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0932 72.5882C30.0932 72.5882 52.248 71.701 57.0357 35.2833C61.2873 2.94077 98.6461 17.6619 109.445 30.5544C123.434 47.2555 115.977 75.9849 134.074 79.6143C152.171 83.2437 140.353 123.596 112.883 119.733C78.7118 114.929 86.9793 134.897 76.7212 143.348C69.3592 149.414 39.1722 143.575 38.1662 121.556C37.3195 103.027 29.5037 103.086 23.9638 100.985C15.9739 97.9546 10.9394 76.0098 30.0932 72.5882Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.407 113.033L83.6406 91.5244L79.3306 95.8863L101.097 117.394L105.407 113.033Z",
    fill: "#E9EAEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.722 118.812L96.7874 102.078C96.6931 101.985 96.5412 101.986 96.448 102.08L90.0385 108.567C89.9453 108.661 89.9462 108.813 90.0405 108.906L106.975 125.64C107.069 125.733 107.221 125.732 107.314 125.638L113.724 119.151C113.817 119.057 113.816 118.905 113.722 118.812Z",
    fill: "#A4A7AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3489 102.341C79.3235 102.341 91.4628 90.2019 91.4628 75.2273C91.4628 60.2526 79.3235 48.1133 64.3489 48.1133C49.3742 48.1133 37.2349 60.2526 37.2349 75.2273C37.2349 90.2019 49.3742 102.341 64.3489 102.341Z",
    fill: "#A4A7AE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3488 97.9173C76.88 97.9173 87.0386 87.7587 87.0386 75.2274C87.0386 62.6962 76.88 52.5376 64.3488 52.5376C51.8175 52.5376 41.6589 62.6962 41.6589 75.2274C41.6589 87.7587 51.8175 97.9173 64.3488 97.9173Z",
    fill: "#D5D7DA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_653_19493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.239 54.8559L109.07 49.8688C108.529 49.5382 107.878 49.4362 107.261 49.5854C106.644 49.7345 106.112 50.1226 105.781 50.6642L95.8072 67.0009C95.4765 67.5425 95.3745 68.1932 95.5237 68.81C95.6728 69.4268 96.0609 69.9591 96.6025 70.2897L108.855 77.7703C109.397 78.101 110.047 78.203 110.664 78.0538C111.281 77.9047 111.813 77.5166 112.144 76.975L119.624 64.7225L117.239 54.8559Z",
    fill: "#A4A7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.239 54.8559L113.498 60.9822L119.624 64.7225",
    fill: "#A4A7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.791 59.5097L106.749 58.2629L108.791 59.5097Z",
    fill: "#A4A7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.239 54.8559L109.07 49.8688C108.529 49.5382 107.878 49.4362 107.261 49.5854C106.644 49.7345 106.112 50.1226 105.781 50.6642L95.8072 67.0009C95.4765 67.5425 95.3745 68.1932 95.5237 68.81C95.6728 69.4268 96.0609 69.9591 96.6025 70.2897L108.855 77.7703C109.397 78.101 110.047 78.203 110.664 78.0538C111.281 77.9047 111.813 77.5166 112.144 76.975L119.624 64.7225M117.239 54.8559L119.624 64.7225M117.239 54.8559L113.498 60.9822L119.624 64.7225M112.423 67.3342L104.255 62.3471M109.93 71.4184L101.761 66.4313M108.791 59.5097L106.749 58.2629",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_653_19493)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1232 109.353L53.4033 112.236C53.0904 112.427 52.8662 112.734 52.78 113.091C52.6939 113.447 52.7528 113.823 52.9439 114.136L58.7082 123.576C58.8993 123.889 59.2069 124.113 59.5633 124.199C59.9197 124.285 60.2957 124.226 60.6087 124.035L67.6884 119.712C68.0014 119.521 68.2256 119.213 68.3117 118.857C68.3979 118.5 68.3389 118.124 68.1478 117.811L63.8247 110.732L58.1232 109.353Z",
    fill: "#A4A7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1232 109.353L60.2848 112.893L63.8247 110.732",
    fill: "#A4A7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1232 109.353L53.4033 112.236C53.0904 112.427 52.8662 112.734 52.78 113.091C52.6939 113.447 52.7528 113.823 52.9439 114.136L58.7082 123.576C58.8993 123.889 59.2069 124.113 59.5633 124.199C59.9197 124.285 60.2957 124.226 60.6087 124.035L67.6884 119.712C68.0014 119.521 68.2256 119.213 68.3117 118.857C68.3979 118.5 68.3389 118.124 68.1478 117.811L63.8247 110.732M58.1232 109.353L63.8247 110.732M58.1232 109.353L60.2848 112.893L63.8247 110.732M62.7075 119.514L60.5459 115.974M59.8567 118.824L63.3966 116.663",
    stroke: "#FAFAFA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_653_19493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28.7113,
    height: 28.7113,
    fill: "white",
    transform: "translate(104.191 44.0864) rotate(31.4056)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_653_19493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5907,
    height: 16.5907,
    fill: "white",
    transform: "translate(49.1428 113.217) rotate(-31.41)"
  })))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMissingCardsWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/missing-cards-white.5f9622d8.svg";
export { ForwardRef as ReactComponent };